import axios from "axios"
import base64Sign from "../../function/base64Sign"
import encryptData from "../../function/encryptData"
import { getToken } from "../../utils/setSessionUser"
import { FETCH_DATA_GETCATLAYER2LIST2_CAT } from "../ActionType/actionTypes"
import {BaseURL} from '../../function/helpers'
import { isLoadingGetCatLayer2List2 } from "./Loading/isLoadingGetCatLayer2List2Actions"

export const fetchDataList2CatLayer2 = (params, url) => {
    return ( dispatch ) => {
        const param = encryptData(params)
        const signature = base64Sign(url)
        const access_token = getToken()
        const headers = {
            'Content-Type':'application/json',
            'sign' : signature,
            'access_token' : access_token
        }
        axios.post(BaseURL + url, {data: param}, {headers: headers})
            .then(layer2List2 => {
                dispatch({
                    type: FETCH_DATA_GETCATLAYER2LIST2_CAT,
                    payload: {
                        getCatLayer2List2: layer2List2.data.response_data.results
                    }
                })
                dispatch(isLoadingGetCatLayer2List2(false))
            })
            .catch(error => console.log(error))
    }
}